import { createStore } from 'vuex'

export default createStore({
  state: {
    curSelectBenchmark: "trial",
    lastVisitRoute: "",
  },
  mutations: {
    updateBenchmark(state, benchmark) {
      state.curSelectBenchmark = benchmark
    },
    commitRoute(state, visitRoute) {
      state.lastVisitRoute = visitRoute
    }
  },
  actions: {
  },
  modules: {
  }
})
